// @flow

import { enableBodyScroll, disableBodyScroll } from "@utils/toggleBodyScroll";

type PropsType = {
    $element: HTMLElement,
};

class NavPrimary {
    props: PropsType;
    $el: HTMLElement;
    $navTop: HTMLElement;
    $searchToggleBtns: NodeList<HTMLButtonElement>;
    $mobileMenuCloseBtns: NodeList<HTMLButtonElement>;
    $mobileMenuBtns: NodeList<HTMLButtonElement>;
    previousScrollTop = 0;
    searchBarActive = false;
    mobileMenuActive = false;
    notificationBarActive = false;

    constructor(props: PropsType) {
        this.$el = props.$element;
        this.$navTop = this.$el
            ? this.$el.querySelector(".nav-primary__top")
            : null;
        this.$searchToggleBtns = document.querySelectorAll(
            "[data-nav-primary-search-toggle]"
        );
        this.$mobileMenuBtns = document.querySelectorAll(
            "[data-nav-primary-mobile-menu-toggle]"
        );
        this.$mobileMenuCloseBtns = document.querySelectorAll(
            "[data-nav-primary-mobile-menu-close]"
        );
        this.$notificationToggleBtn = document.querySelectorAll(
            "[data-notification]"
        );
        this.$sidebar = document.getElementsByClassName("js-sidebar")[0];

        this.attachEvents();
        this.init();
    }

    attachEvents() {
        if (this.$el) {
            window.addEventListener("scroll", () => {
                this.navShrinkExpand();
            });
        }

        if (this.$notificationToggleBtn) {
            this.$notificationToggleBtn.forEach(el => {
                el.addEventListener("click", (): void =>
                    this.toggleNotificationBar()
                );
            });
        }

        if (this.$searchToggleBtns) {
            this.$searchToggleBtns.forEach(el => {
                el.addEventListener("click", (): void =>
                    this.toggleSearchBar()
                );
            });
        }

        if (this.$mobileMenuBtns) {
            this.$mobileMenuBtns.forEach(el => {
                el.addEventListener("click", (): void =>
                    this.toggleMobileMenu()
                );
            });
        }

        if (this.$mobileMenuCloseBtns) {
            this.$mobileMenuCloseBtns.forEach(el => {
                el.addEventListener("click", (): any => {
                    if (this.mobileMenuActive) {
                        this.closeMobileMenu();
                    } else if (this.searchBarActive) {
                        this.closeSearchBar();
                    }
                });
            });
        }
    }

    init() {}

    navShrinkExpand() {
        if (this.$navTop) {
            const scrollTop = window.scrollY;
            const navTopHeight = this.$navTop.clientHeight;

            //shrink/hide top nav
            if (
                scrollTop <= 0 ||
                (this.previousScrollTop && this.previousScrollTop > scrollTop)
            ) {
                //scrolled up
                this.$el.classList.remove("shrink");
                this.$el.style.transform = `none`;
            } else {
                //scrolled down
                this.$el.classList.add("shrink");
                this.$el.style.transform = `translate3d(0, -${navTopHeight}px, 0)`;
            }

            this.previousScrollTop = scrollTop;
        }
    }

    toggleSearchBar() {
        // this.searchBarActive = !this.searchBarActive;

        if (!this.searchBarActive) {
            this.openSearchBar();
        } else {
            this.closeSearchBar();
        }
    }

    openSearchBar() {
        this.searchBarActive = true;
        this.$el.classList.add("search-bar-active");
    }

    closeSearchBar() {
        this.searchBarActive = false;
        this.$el.classList.remove("search-bar-active");
    }

    toggleMobileMenu() {
        // this.mobileMenuActive = !this.mobileMenuActive;

        if (!this.mobileMenuActive) {
            this.openMobileMenu();
        } else {
            this.closeMobileMenu();
        }
    }

    toggleNotificationBar() {
        if (!this.mobileMenuActive) {
            this.openNotificationBar();
        } else {
            this.closeNotificationBar();
        }
    }

    openNotificationBar() {
        this.notificationBarActive = true;
        this.$sidebar.classList.add("is-active");
    }

    closeNotificationBar() {
        this.notificationBarActive = false;
        this.$sidebar.classList.remove("is-active");
    }

    openMobileMenu() {
        this.mobileMenuActive = true;
        disableBodyScroll();
        this.$el.classList.add("mobile-menu-active");
    }

    closeMobileMenu() {
        this.mobileMenuActive = false;
        enableBodyScroll();
        this.$el.classList.remove("mobile-menu-active");
    }
}

export default NavPrimary;
